import type { Undefinable } from "@core/domain/types/undefinable.type";
import * as z from "zod";

const NotebookMessageFileDtoSchema = z.object({
    id: z.number(),
    url: z.string().trim(),
});

export const NotebookMessageDtoSchema = z.object({
    id: z.number(),
    title: z.string().trim(),
    description: z.string().trim(),
    time: z.string().trim(),
    user_id: z.number(),
    user_email: z.string().trim(),
    files: z.array(NotebookMessageFileDtoSchema).nullable(),
});
export type NotebookMessageDto = z.output<typeof NotebookMessageDtoSchema>;

export const NotebookMessagesDtoSchema = z
    .array(NotebookMessageDtoSchema)
    .readonly();
export type NotebookMessagesDto = z.output<typeof NotebookMessagesDtoSchema>;

export interface NotebookMessageCreateBodyContent {
    notebook_message: {
        title: NotebookMessageDto["title"];
        description: NotebookMessageDto["description"];
        time: Undefinable<NotebookMessageDto["time"]>;
        user_id: NotebookMessageDto["user_id"];
    };
}
export type NotebookMessageCreateBody = FormData;

export interface NotebookMessageUpdateBodyContent {
    notebook_message: {
        id: NotebookMessageDto["id"];
        title: NotebookMessageDto["title"];
        description: NotebookMessageDto["description"];
        time: Undefinable<NotebookMessageDto["time"]>;
        user_id: NotebookMessageDto["user_id"];
    };
}
export type NotebookMessageUpdateBody = FormData;

export interface NotebookMessageFileBodyContent {
    notebook_message: {
        files: Undefinable<File[]>;
    };
}
export type NotebookMessageFileBody = FormData;
